import React, { useState, useEffect } from "react";
import { Box, Typography, TextField } from "@mui/material";
import { getExternalAccounts } from "../../../util/API/externalaccounts";
import { GetListOfPaymentInstruments } from "../../../util/API/admin";
import { useSelector, useDispatch } from "react-redux";

function PaymentInstruments() {
  const [paymentInstruments, setPaymentInstruments] = useState([]);
  const userInfo = useSelector((state) => state.login.user);

  let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body;

  // const ProfileBalance = async () => {
  //   const response = await getExternalAccounts(agent['User'].id);
  //   console.log(response)
  //   setProfileBalance(response?.payload?.body?.record || []);
  // };

  useEffect(() => {
    // ProfileBalance();
    getListOfPIs();
  }, []);

  const getListOfPIs = async() => {
    try {
      const response = await GetListOfPaymentInstruments(userInfo?.id);
      if(response?.data?.header?.callStatus === "1") {
        setPaymentInstruments(response?.data?.body?.record);
      }
    } catch (error) {
      console.error("Error fetching list of payment instruments:", error);
    }
  }

  // const renderBalances = () => {
  //   if (Array.isArray(profileBalance)) {
  //     return profileBalance.map(({ Vacctbalance }) => (
  //       <Box
  //         key={Vacctbalance.acctID}
  //         sx={{
  //           padding: 1.5,
  //           marginBottom: 1.5,
  //           display: "flex",
  //           justifyContent: "space-between",
  //           alignItems: "center",
  //         }}
  //       >
  //         <TextField
  //           variant="standard"
  //           label={`Account ${Vacctbalance.acctID}`}
  //           value={`${Vacctbalance.symbol + Vacctbalance.balance + " (" + Vacctbalance.currCode + ")"}`}
  //           InputProps={{
  //             readOnly: true,
  //             sx: { height: "40px", padding: "0 8px" },
  //           }}
  //           InputLabelProps={{
  //             sx: { fontSize: "0.875rem", lineHeight: "1.2" },
  //           }}
  //           sx={{
  //             flex: 1,
  //           }}
  //           fullWidth
  //           disabled
  //         />
  //       </Box>
  //     ));
  //   } else if (profileBalance?.Vacctbalance) {
  //     return (
  //       <Box
  //         sx={{
  //           padding: 1.5,
  //           marginBottom: 1.5,
  //           display: "flex",
  //           justifyContent: "space-between",
  //           alignItems: "center",
  //         }}
  //       >
  //         <TextField
  //           variant="standard"
  //           label={`Account ${profileBalance.Vacctbalance.acctID}`}
  //           value={`$${profileBalance.Vacctbalance.balance}`}
  //           InputProps={{
  //             readOnly: true,
  //             sx: { height: "40px", padding: "0 8px" },
  //           }}
  //           InputLabelProps={{
  //             sx: { fontSize: "0.875rem", lineHeight: "1.2" },
  //           }}
  //           sx={{
  //             flex: 1,
  //           }}
  //           fullWidth
  //           disabled
  //         />
  //       </Box>
  //     );
  //   } else {
  //     return <Typography>No balance information available</Typography>;
  //   }
  // };

  return (
    <Box
      sx={{
        backgroundColor: "#f9f9f9",
        padding: 2,
        borderRadius: 2,
        marginBottom: 2,
      }}
    >
      <Typography variant="h6" sx={{ marginBottom: 2, fontFamily: "Nunito" }}>
        Payment Instruments
      </Typography>

      <Box
        sx={{
          p: 1,
          backgroundColor: "white",
          borderRadius: "8px",
          boxShadow: 0.2,
          display:"flex",
          flexDirection:"column"
        }}
      >
        {
          paymentInstruments && paymentInstruments.length >0 && paymentInstruments.map((val, idx)=> {
            return (
              <Box
                key={idx}
                sx={{
                  padding: 1.5,
                  marginBottom: 1.5,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <TextField
                  variant="standard"
                  label={`Payment Instrument ${idx + 1}`}
                  value={val?.paymentinstrument?.name}
                  InputProps={{
                    readOnly: true,
                    sx: { height: "40px", padding: "0 8px" },
                  }}
                  InputLabelProps={{
                    sx: { fontSize: "0.875rem", lineHeight: "1.2" },
                  }}
                  sx={{
                    flex: 1,
                  }}
                  fullWidth
                  disabled
                />
              </Box>
              // <span>{val?.paymentinstrument?.name}</span>
            )
          })
        }
      </Box>
    </Box>
  );
}

export default PaymentInstruments;
